/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { useRouter } from "next/navigation";

interface FeaturedProductItem {
  id: number;
  title?: string;
  description?: string;
  image: string;
  url?: string | null;
  banner_links?: Array<{
    id: number;
    linkable_type?: string | null;
    linkable_id?: number;
    banner_management_id?: number;
    type?: string;
  }>;
}

interface HomeFeaturedProductsProps {
  featuredProducts?: FeaturedProductItem[];
}

function HomeFeaturedProducts({ featuredProducts = [] }: HomeFeaturedProductsProps) {
  const router = useRouter();

  // Don't render if no featured products
  if (!featuredProducts || featuredProducts.length === 0) {
    return null;
  }

  const handleProductClick = (product: FeaturedProductItem) => {
    if (product.url) {
      router.push(product.url);
    } else if (product.banner_links && product.banner_links.length > 0) {
      const hasAllKeys = product.banner_links.every(
        (link) => link?.linkable_id && link?.linkable_type && link?.type
      );

      if (hasAllKeys) {
        const firstLink = product.banner_links[0];
        if (firstLink.type === "brand") {
          router.push(
            `/product/product-category?brandIds=${product.banner_links
              .map((link) => link?.linkable_id)
              .join(",")}`
          );
        } else if (firstLink.type === "category") {
          router.push(
            `/product/product-category?categoryIds=${product.banner_links
              .map((link) => link?.linkable_id)
              .join(",")}`
          );
        } else if (firstLink.type === "product") {
          router.push(
            `/product/product-category?productIds=${product.banner_links
              .map((link) => link?.linkable_id)
              .join(",")}`
          );
        } else {
          router.push("/product/product-category?type=recommended");
        }
      } else {
        router.push("/product/product-category?type=recommended");
      }
    } else if (product.title) {
      router.push(`/product/product-category?type=featured_products&search=${encodeURIComponent(product.title)}`);
    }
  };

  return (
    <>
      <section className="homePromotion_sc">
        <div className="container">
          <div className="s_head flex hd_4">
            <h2 className='fw_med'>Featured Products</h2>
          </div>
          <ul className="promotion_grid gap_m">
            {featuredProducts.map((product) => (
              <li 
                key={product.id}
                onClick={() => handleProductClick(product)}
                style={{ cursor: product.url || product.banner_links?.length ? 'pointer' : 'default' }}
              >
                <figure>
                  <img 
                    src={product.image} 
                    alt={product.title || product.description || "featured product"} 
                  />
                </figure>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  )
}

export default HomeFeaturedProducts